import take from '../take';

export default function dropLast(n, xs) {
  return take(n < xs.length ? xs.length - n : 0, xs);
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/ramda/es/internal/_dropLast.js
// module id = ../node_modules/ramda/es/internal/_dropLast.js
// module chunks = 5